<section class="card" id="cardContainer">
  <div id="cardContainer2"></div>
  <div class="modal-body">
    <!-- Serie proposals with issues -->
    <ng-container *ngIf="serieProposalItemsWithConflicts.length > 0">
      <div class="alert alert-danger text-center">
        <h4 class="mb-0">{{ 'general.seriesConflicts' | translate }}</h4>
      </div>
      <h3>{{ 'serieProposalModule.seriesWithIssues' | translate }}</h3>

      <serie-proposal-item-table
        [tableData]="serieProposalItemsWithConflictsEnriched$ | async"
        [bulkActions]="[bulkAction.DECLINE]"
        [showSearchField]="false"
        (onBulkAction)="onBulkAction($event)"
        [refreshData$]="refreshData$.asObservable()"
        [showEditButton]="true"
      ></serie-proposal-item-table>
    </ng-container>

    <!-- Serie proposals without issues -->
    <h3 class="mt-3">{{
      'serieProposalModule.seriesWithoutIssues' | translate
    }}</h3>

    <serie-proposal-item-table
      [tableData]="serieProposalItemsWithoutConflicts"
      [showSearchField]="false"
      (onBulkAction)="onBulkAction($event)"
      [refreshData$]="refreshData$.asObservable()"
    ></serie-proposal-item-table>

    <div class="d-flex mt-3 justify-content-between">
      <button class="btn btn-soft-secondary" (click)="cancel()" type="button">
        {{ 'general.close' | translate }}
      </button>

      <button
        type="button"
        class="btn btn-primary"
        [disabled]="isLoading || serieProposalItemsWithConflicts.length"
        (click)="onClickAccept()"
      >
        {{ 'general.accept' | translate }}
      </button>
    </div>
  </div>
</section>
